<template>
  <div>
    <calculator-field :value="form.send" :only="{ title: 'Real Brasileiro', currency: 'BRL' }" :btn-style="primaryBtnStyle()" label="Você envia" />

    <v-layout wrap style="margin-top: -24px;">
      <v-flex xs12 class="calculation-line">
        <div class="line">{{form.receive.currency}} 1 = {{form.send.currency}} {{fx_exchange_rate}}</div>
        <div class="dash">&nbsp;</div>
        <div class="circle">&nbsp;</div>
      </v-flex>
    </v-layout>

    <calculator-field :value="form.receive" :only="{ title: 'Dólar Americano', currency: 'USD' }" :btn-style="primaryBtnStyle()" label="Beneficiário recebe" />

    <v-layout style="margin-top: -10px;" class="mb-3">
      <v-flex xs12>
        <v-btn
          block
          dark
          class="ma-0"
          :style="secondaryBtnStyle()"
          @click="$router.push('/sign_in')"
        >
          ENVIAR
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import CalculatorField from './CalculatorField'

export default {
  name: 'USBBRLCalculator',
  components: { 'calculator-field': CalculatorField },
  data () {
    return {
      form: {
        send: { value: 1000, currency: 'BRL' },
        receive: { value: 1261.43, currency: 'USD' }
      },
      firstFieldCurrency: 'BRL',
      secondFieldCurrency: 'USD',
      shouldCalculateConversion: true,
      exchange_rate: 3.86,
      fx_exchange_rate: 4.0,
      fx_rate: 0.03,
      iof_rate: 0.011, //iof_rate: 0.0,
      fx_value: 0,
      iof_value: 0
    }
  },
  computed: {
    sendCurrency() {
      return this.form.send.currency
    },
    receiveCurrency() {
      return this.form.receive.currency
    },
    receiveValue() {
      return this.form.receive.value
    },
    sendValue() {
      return this.form.send.value
    }
  },
  watch: {
    sendValue(new_value, old_value) {
      if (new_value == old_value) return

      this.calculateConversion('sender')
    },
    receiveValue(new_value, old_value) {
      if (new_value == old_value) return

      this.calculateConversion('receiver')
    }
  },
  methods: {
    enableCalculation() {
      this.shouldCalculateConversion = true
    },
    disableCalculation() {
      this.shouldCalculateConversion = false
    },
    nextCurrencyFor(currency_to_switch) {
      if (currency_to_switch == 'USD') {
        return 'BRL'
      } else {
        return 'USD'
      }
    },
    getCssProperty(prop_name) {
      return getComputedStyle(document.documentElement, null).getPropertyValue(prop_name)
    },
    primaryBtnStyle() {
      return `height: 56px; background-color: ${this.getCssProperty('--primary-button-background-color')};`
    },
    secondaryBtnStyle() {
      return `height: 56px; background-color: ${this.getCssProperty('--secondary-button-background-color')};`
    },
    calculateConversion(from) {
      if (!this.shouldCalculateConversion) {
        return
      }

      let value_to_exchange = 0
      let fx_exchange_rate_with_iof = 0
      let iof_final_rate = 0
      let sent_ted_tax = 0
      let receive_ted_tax = 0
      let fx_rate = this.fx_rate
      let iof_rate = this.iof_rate
      let exchange_rate = this.exchange_rate
      let value = this.sendValue
      let number_of_transactions = 1
      let ted_tax = 0

      if (from == 'receiver') {
        value = this.receiveValue
        let fx_exchange_rate = (exchange_rate * (1 - fx_rate))
        fx_exchange_rate_with_iof = (fx_exchange_rate * (1 - iof_rate)).toFixed(8)
        ted_tax = (number_of_transactions * sent_ted_tax).toFixed(2)
        if (exchange_rate > 0) {
          value_to_exchange = ((value * fx_exchange_rate_with_iof) - ted_tax).toFixed(2)
        }
      } else {
        let fx_value = value * fx_rate
        ted_tax = (number_of_transactions * receive_ted_tax).toFixed(2)
        let value_without_taxes = (value - ted_tax - fx_value)
        let value_without_taxes_with_iof = (value_without_taxes / (1 + iof_rate))

        if (exchange_rate > 0) {
          value_to_exchange = (value_without_taxes_with_iof / exchange_rate).toFixed(2)
        }
        this.fx_exchange_rate = (value / value_to_exchange).toFixed(2)
      }

      this.iof_value = (value * this.iof_rate).toFixed(2)

      if (from == 'sender') {
        let bank_brl_value = (value_to_exchange * exchange_rate).toFixed(2)
        let bank_iof_value = (Number(bank_brl_value) * iof_rate).toFixed(2)
        let bank_charged_value = Number(bank_iof_value) + Number(bank_brl_value)
        this.fx_value = (value - bank_charged_value - ted_tax).toFixed(2)
        this.iof_value = bank_iof_value

        // this.fx_value = ((Number(value_to_exchange) * (Number(fx_exchange_rate_with_iof) - this.exchange_rate)) + Number(ted_tax)).toFixed(2)
      } else {
        this.fx_value = ((value * (this.exchange_rate - Number(fx_exchange_rate_with_iof))) + Number(ted_tax)).toFixed(2)
      }

      if (from == 'receiver') {
        this.form.send.value = value_to_exchange
      } else {
        this.disableCalculation()
        this.form.receive.value = value_to_exchange
        this.$nextTick(function () {
          this.enableCalculation()
        })
      }
    },
    calculateConversionBackup(from) {
      if (!this.shouldCalculateConversion) {
        return
      }

      let value_to_exchange = 0
      let fx_exchange_rate_with_iof = 0
      let iof_final_rate = 0
      let sent_ted_tax = 0
      let receive_ted_tax = 0
      let fx_rate = this.fx_rate
      let iof_rate = this.iof_rate
      let exchange_rate = this.exchange_rate
      let value = this.sendValue
      let number_of_transactions = 1
      let ted_tax = 0

      if (from == 'receiver') {
        value = this.receiveValue
        let fx_exchange_rate = (exchange_rate * (1 - fx_rate))
        fx_exchange_rate_with_iof = (fx_exchange_rate * (1 - iof_rate)).toFixed(8)
        ted_tax = (number_of_transactions * sent_ted_tax).toFixed(2)
        if (exchange_rate > 0) {
          value_to_exchange = ((value * fx_exchange_rate_with_iof) - ted_tax).toFixed(2)
        }
      } else {
        let fx_exchange_rate = (exchange_rate * (1 + fx_rate))
        fx_exchange_rate_with_iof = (fx_exchange_rate * (1 + iof_rate)).toFixed(8)
        ted_tax = (number_of_transactions * receive_ted_tax).toFixed(2)
        let value_without_taxes = (value - ted_tax)
        if (exchange_rate > 0) {
          value_to_exchange = (value_without_taxes / fx_exchange_rate_with_iof).toFixed(2)
        }
      }

      this.iof_value = (value * this.iof_rate).toFixed(2)

      if (from == 'sender') {
        let bank_brl_value = (value_to_exchange * exchange_rate).toFixed(2)
        let bank_iof_value = (Number(bank_brl_value) * iof_rate).toFixed(2)
        let bank_charged_value = Number(bank_iof_value) + Number(bank_brl_value)
        this.fx_value = (value - bank_charged_value).toFixed(2)
        this.iof_value = bank_iof_value

        // this.fx_value = ((Number(value_to_exchange) * (Number(fx_exchange_rate_with_iof) - this.exchange_rate)) + Number(ted_tax)).toFixed(2)
      } else {
        this.fx_value = ((value * (this.exchange_rate - Number(fx_exchange_rate_with_iof))) + Number(ted_tax)).toFixed(2)
      }

      if (from == 'receiver') {
        this.form.send.value = value_to_exchange
      } else {
        this.disableCalculation()
        this.form.receive.value = value_to_exchange
        this.$nextTick(function () {
          this.enableCalculation()
        })
      }
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.calculateConversion('sender')
    })
  }
}
</script>

<style>
  .field-height { height: 62px; }
  .calculation-line { position: relative; height: 40px; padding-top: 12px; }
  .calculation-line .line { padding-left: 40px; }
  .calculation-line .dash { position: absolute; left: 16px; top: -4px; width: 2px; height: 48px; background-color: var(--primary-button-background-darker-color); }
  .calculation-line .circle { position: absolute; left: 7px; top: 12px; width: 20px; height: 20px; background-color: var(--primary-button-background-darker-color); border-radius: 20px; }
  .currency-flag { width: 30px; height: 20px; border-radius: 2px; }
</style>



// WEBPACK FOOTER //
// src/USDBRLCalculator.vue